import React from 'react';
import Modal from '../Modal';
import Button from '../Button';
import Loader from '../Loader';
import translations from '../../translations/de';
import useLockBodyScroll from '../../customHooks/useLockBodyScroll';
import './index.scss';

// Closing is disabled while the check runs, so the request always gets to
// finish and its answer is always seen.
const TixxConnectModal = ({ loading, result, onClose }) => {
    useLockBodyScroll();

    return (
        <Modal
            title={translations.tixx_connect_title}
            onClose={onClose}
            maxWidth="420px"
            disabled={loading}
        >
            <div className="tixx-connect_modal">
                {loading ? (
                    <>
                        <Loader theme="dark" />
                        <p>{translations.tixx_checking}</p>
                    </>
                ) : (
                    <>
                        <p className={result?.ok ? 'tixx-connect_ok' : 'tixx-connect_error'}>
                            {result?.text}
                        </p>
                        <Button label={translations.close} onClick={onClose} />
                    </>
                )}
            </div>
        </Modal>
    );
};

export default TixxConnectModal;
